/* eslint-disable */
import axios from "axios";
import '../utils/axios.interceptor';
import { urlCoreBack } from "../configs/config";
const epName = "v1/login/";
const epNameChangePassword = "v1/usuario/change-password/";
//
// #############################################################################
//
export const login = async (item) => {
  let _errorMessage = `No fue posible iniciar sesión`;

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epName}`,
      data: item,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Login ok";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-usuario-user-not-exist" || response.data.code === "err-password-incorrect") {
        response.ok = false;
        response.messageText = "Error de usuario o de contraseña";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-usuario-user-no-roles-asignados") {
        response.ok = false;
        response.messageText = "El usuario no tiene roles asinados en el Sistema";
        response.messageSeverity = "error";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;

  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const changePassword = async (item) => {
  let _errorMessage = `No fue posible cambiar la contraseña`;

  try {
    const response = await axios({
      method: "PUT",
      url: `${urlCoreBack}${epNameChangePassword}`,
      data: item,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Contraseña cambiada";
        response.messageSeverity = "success";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;

  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
